import { render, staticRenderFns } from "./Brandtopsale.vue?vue&type=template&id=4704eda8&scoped=true"
import script from "./Brandtopsale.vue?vue&type=script&lang=js"
export * from "./Brandtopsale.vue?vue&type=script&lang=js"
import style0 from "./Brandtopsale.vue?vue&type=style&index=0&id=4704eda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704eda8",
  null
  
)

export default component.exports